<template>
  <div>
    <b-row>
      <b-modal
        :no-close-on-backdrop="true"
        id="modal-radiology-edit"
        ok-only
        centered
        size="lg"
        :title="
          createMode ? 'Add Patient  Radiology' : 'Edit Patient  Radiology'
        "
        @ok="submitItem()"
      >
        <b-card-text>
          <b-row>
            <b-col md="">
              <b-form-group label="URL" label-for="URL">
                <b-form-input v-model="EditForm.url" placeholder="URL" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>
      </b-modal>

      <b-col>
        <b-card>
          <div class="d-flex justify-content-between">
            <h2 class="mb-2">Patient Radiology Details</h2>
            <h2 class="mb-2"></h2>
          </div>
          <div class="mb-4">
            <h5>Patient Name : {{ patientInfo.patient.name }}</h5>
            <h6>Patient Gender : {{ patientInfo.patient.gender }}</h6>
            <h6>Patient Height : {{ patientInfo.patient.height }}</h6>
            <h6>Patient Phone Number : {{ patientInfo.patient.phone }}</h6>
            <h6>Patient Case : {{ patientInfo.patient_case }}</h6>
            <h6>Type : {{ patientInfo.type }}</h6>
          </div>
          <div class="row">
            <div
              class="col-md-3 mb-4"
              v-for="(radiology, index) in data"
              :key="index"
            >
              <b-card
                title="Radiology"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 20rem"
                class="mb-2 border border-dark h-100"
              >
                <b-card-text>
                  <div
                    class="d-flex justify-content-between mt-2 align-items-center"
                  >
                    <div class="fw-semibold fs-6 text-black">Type</div>
                    <div>{{ radiology.type === 0 ? "Sonar" : "CXR" }}</div>
                  </div>
                  <div class="mt-2 align-items-center">
                    <div class="fw-semibold fs-6 text-black fw-bold">URL:</div>

                    <div class="fw-semibold fs-7 text-black mt-1 mx-2">
                      {{ radiology.url }}
                    </div>
                  </div>
                </b-card-text>

                <b-button
                  variant="primary"
                  @click="show(radiology, 'update')"
                  class="mt-4 w-100"
                >
                  Edit
                </b-button>
              </b-card>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BFormGroup,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import router from "@/router";
import ReceptionHistoryCard from "@/components/reception/ReceptionHistoryCard";
import ReceptionPatientCardWithQR from "@/components/reception/ReceptionPatientCardWithQR";
import VueHtml2pdf from "vue-html2pdf";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
// const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BButton,
    ReceptionHistoryCard,
    ReceptionPatientCardWithQR,
    VueHtml2pdf,
    StatisticCardHorizontal,
    BFormGroup,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormInput,
  },

  data() {
    return {
      data: {},
      patientCardDetails: {},
      params: {
        form: {},
        path: "",
      },
      EditForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
        _method: "PUT",
      },
      patientInfo: {},
    };
  },
  mounted() {
    this.getPatientInfo();
    this.getPatientsInfo();
  },

  methods: {
    async getPatientsInfo() {
      const Id = this.$route.params.id;
      await this.getPatient(`/patientCard/${Id}`);
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }

      this.patientInfo = this.all_data;
      console.log("patientInfo", this.all_data);
    },
    async getPatientInfo() {
      const Id = this.$route.params.id;

      await this.getPatient(
        `patientCardRadiology?include=radiology&filter[patient_card_id]=${Id}`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }

      this.data = this.all_data.data;

      this.EditForm.id = this.data[0].id;
      this.EditForm.url = this.data[0].url;
      this.EditForm.patient_card_id = this.data[0].patient_card_id;
      this.EditForm.radiology_id = this.data[0].radiology_id;
      this.EditForm.type = this.data[0].type.toString();
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardRadiology`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Patient Card Radiology Added",
                  variant: "success",
                },
              });
              this.getPatientsRadiologies();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardRadiology/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientInfo();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          type: "",
          url: "",
          patient_card_id: this.patientCardId,
          radiology_id: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        console.log("item", item);
        this.EditForm.id = item.id;
        this.EditForm.url = item.url;
        this.EditForm.patient_card_id = item.patient_card_id;
        this.EditForm.radiology_id = item.radiology_id;
        this.EditForm.type = item.type.toString();

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-radiology-edit");
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
